import convertUnitFromMap from 'helpers/convertUnitFromMap'

class OverlayView extends google.maps.OverlayView {
  constructor({ map, polyline, isImperial, containerClassName }) {
    super()
    this.polyline = polyline
    this.isImperial = isImperial
    this.setMap(map)
    this.shouldDisplay = this.shouldDisplay.bind(this)
    this.draw = this.draw.bind(this)
    this.containerClassName = containerClassName
  }

  setIsImperial(isImperial) {
    this.isImperial = isImperial
    this.draw()
  }

  getPoints() {
    return this.polyline.getPath().getArray()
  }

  calculateDistance() {
    const points = this.getPoints()
    return google.maps.geometry.spherical.computeDistanceBetween(points[0], points[points.length - 1]).toFixed(2)
  }

  calculatePosition() {
    const points = this.getPoints()
    const distance = this.calculateDistance()
    const heading = google.maps.geometry.spherical.computeHeading(points[0], points[points.length - 1]).toFixed(2)
    return google.maps.geometry.spherical.computeOffset(points[0], distance / 2, heading)
  }

  isLine() {
    return this.polyline.getPath().getArray().length === 2
  }

  shouldDisplay() {
    return this.polyline.getEditable() && this.isLine()
  }

  onAdd() {
    const el = this.containerElement = document.createElement('div')
    this.span = document.createElement('span')
    el.appendChild(this.span)
    el.className += this.containerClassName
    let panes = this.getPanes()
    panes.overlayMouseTarget.appendChild(el)

    google.maps.event.addListener(this.polyline, 'selected', this.draw)
    google.maps.event.addListener(this.polyline, 'deselected', this.draw)
    google.maps.event.addListener(this.polyline, 'drag', this.draw)
  }

  draw() {
    const { shouldDisplay, isImperial } = this
    let latLngPxl

    const length = convertUnitFromMap({ value: this.calculateDistance(), isImperial }).toFixed(2)
    const unit = isImperial ? 'ft' : 'm'
    if (this.span) this.span.textContent = `${length}${unit}`

    const overlayProjection = this.getProjection()
    if (overlayProjection) {
      latLngPxl = overlayProjection.fromLatLngToDivPixel(this.calculatePosition())
    }

    if (this.containerElement && latLngPxl) {
      this.containerElement.style.display = shouldDisplay() ? 'block' : 'none'
      this.containerElement.style.left = (latLngPxl.x - this.containerElement.offsetWidth / 2) + 'px'
      this.containerElement.style.top = (latLngPxl.y + 10) + 'px'
    }
  }

  onRemove() {
    this.containerElement.parentNode.removeChild(this.containerElement)
  }
}

export default OverlayView



// WEBPACK FOOTER //
// ./src/components/Markup/LineLengthOverlay.js